var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconExchange = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 12.5019307 12.5",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_draw down")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bswap",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IP-\\u8BE6\\u60C5",
    transform: "translate(-613.999035, -223.000965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10",
    transform: "translate(129.000000, 166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_draw-down",
    transform: "translate(491.000000, 63.000000) rotate(-90.000000) translate(-491.000000, -63.000000) translate(483.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70497171,7.77397724 C5.95341364,7.70000296 5.96178808,7.5660118 5.96178808,7.5660118 L5.92968604,5.8939139 L9.41764318,5.83110555 C9.41764318,5.83110555 12.1044449,6.16608343 12.1784192,7.21847226 C12.1588788,6.86116252 11.9146241,3.86171478 9.29900518,3.90777424 L5.89897973,3.96779111 L5.86548194,2.15891057 C5.86548194,2.15891057 5.82640119,2.02910665 5.60308261,2.00258756 C5.4537383,1.98444293 5.36161939,2.06679166 5.32951734,2.091915 L1.82201982,4.50235997 C1.82201982,4.50235997 1.49262491,4.68938929 1.4981377,5.04530328 C1.50379084,5.39284283 1.74106683,5.5310212 1.74106683,5.5310212 L5.35464068,7.74047945 C5.35464068,7.74047945 5.50398498,7.83399411 5.70497171,7.77397724 Z M12.2297841,7.219868 C12.2422841,7.25964073 12.2422841,7.29941345 12.2422841,7.344868 C12.2422841,7.31645891 12.2297841,7.27668618 12.2297841,7.219868 Z M13.7542109,10.9688287 L10.1462201,8.76076623 C10.1462201,8.76076623 9.91871426,8.67702176 9.72749772,8.72308122 C9.51953229,8.7733279 9.52511525,8.93523388 9.52511525,8.93523388 L9.5572173,10.6045403 L6.08600905,10.6659529 C6.08600905,10.6659529 3.40199881,10.330975 3.32802452,9.27998194 C3.3475649,9.6345002 3.59042386,12.6339479 6.20464704,12.5878885 L9.5879236,12.5278716 L9.62142139,14.3339607 C9.62142139,14.3339607 9.61723417,14.4470157 9.82799108,14.4930752 C10.0038545,14.5307602 10.1713434,14.402352 10.1713434,14.402352 C10.2453177,14.3451266 13.6760494,11.9960942 13.6760494,11.9960942 C13.6760494,11.9960942 14.0054444,11.8104607 13.9999316,11.4545467 C13.9914869,11.1056114 13.7542109,10.9688287 13.7542109,10.9688287 L13.7542109,10.9688287 Z M3.38075434,9.3242448 L3.38075434,9.2867448 L3.38075434,9.3242448 Z M3.38770221,9.37706712 C3.38770221,9.33540045 3.37520221,9.29373379 3.37520221,9.25206712 C3.37520221,9.27587664 3.37520221,9.31754331 3.38770221,9.37706712 Z",
    id: "\\u5F62\\u72B6",
    fill: "#3B199F",
    fillRule: "nonzero",
    transform: "translate(7.749035, 8.250000) rotate(-90.000000) translate(-7.749035, -8.250000) "
  })))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconExchange, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_exchange.813a757d.svg";
export { ForwardRef as ReactComponent };